import {IntegrationMessage} from "platform/integration/message/IntegrationMessage";
import {IntegrationClassId} from "platform/integration/message/IntegrationClassId";

export class IntegrationShowLoading implements IntegrationMessage {

    public classId: number = IntegrationClassId.SHOW_LOADING;

}
